'use client';

import Image from "next/image";
import { useState } from "react";
import { useFormik } from "formik";
import axios from "axios";
import { useRouter } from "next/navigation";

export default function Page() {

    const [showPassword, setShowPassword] = useState(false);
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const router = useRouter();

    const apiUrl = process.env.NEXT_PUBLIC_API_BASE;

    const showMessage = (msg, duration = 2000) => {
        setMessage(msg);
        setTimeout(() => {
            setMessage(null);
        }, duration);
    };

    const{ handleChange, handleSubmit, values, resetForm } = useFormik({
        initialValues: {
            userEmail: "",
            userPassword: "",
        },
        onSubmit: async () => {
            try {
                setLoading(true);
                const res = await axios.post(`${apiUrl}/user/adminLogin`, values, {
                    withCredentials: true
                });
                resetForm();
                showMessage(res.data.message);
                setTimeout(() => {
                    router.push("/dashboard/heroBanner/add");
                }, 2000);
            } catch (error) {
                showMessage(error?.response?.data?.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        }
    });

    return(
        <>
            <div className="authentication">
                <div className="account-pages">
                    <div className="container">
                        <div className="justify-content-center row">
                            <div className="col-md-9">
                                <div className="card">
                                    <div className="g-0 row">
                                        <div className="d-none d-lg-block p-2 col-lg-5">
                                            <div className="image-box">
                                                <Image src='/images/auth-img.webp' width={386} height={544} alt="auth-img" className="rounded h-100" priority style={{
                                                    width: "100%",
                                                    height: "auto",  
                                                }} />
                                            </div>
                                        </div>
                                        <div className="col-lg-7">
                                            <div className="logo-box p-4">
                                                <Image src='/images/onesoul-logo.webp' width={200} height={70} alt="onesoul-logo" style={{
                                                    width: "auto",
                                                    height: "60px",
                                                }}  />
                                            </div>
                                            <div className="account-form p-4">
                                                <h4>Login to One Soul Wellness Admin</h4>
                                                <p>Enter your email address and password to access account.</p>
                                                <form onSubmit={handleSubmit}>
                                                    <div className="form-group mb-3">
                                                        <label className="form-label">Email address*</label>
                                                        <input name="userEmail" placeholder="Enter your email" type="email" className="form-control" value={values.userEmail} onChange={handleChange} />
                                                    </div>
                                                    <div className="form-group mb-4">
                                                        <label className="form-label">Password*</label>
                                                        <div className="input-group">
                                                            <input name="userPassword" placeholder="Enter your password" type={showPassword ? 'text' : 'password'} className="form-control" value={values.userPassword} onChange={handleChange} />
                                                            <div  className={`input-group-text ${
                                                                showPassword ? 'show-password' : ''
                                                            }`}>
                                                                <span className="password-eye" onClick={() => {
                                                                    setShowPassword(!showPassword)
                                                                }}></span>
                                                            </div>
                                                        </div>
                                                        <p>Password Min 8 chars, 1 upper, 1 lower, 1 number, 1 special (@, $, !, %, *, ?, &amp;).</p>
                                                    </div>
                                                    <div className="button-group">
                                                        <button type="submit" className="custom-btn btn" disabled={loading}>{loading ? "Signing In..." : "Sign In"}</button>
                                                    </div>
                                                    {message && <div className="response-output mt-3">{message}</div>}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}